import React, { useEffect, useState } from 'react';
import { Tree } from 'antd';
import ItemWrap from '../components/item-wrap';
import useProps from '../../_util/useProps';
import classname from 'classnames';
import Icon from '@ant-design/icons/lib/components/Icon';
import { getImage } from '../../renderer';
import { isString, isObject, isFunction } from 'lodash';

export const getIcon = _options => {
    let options = isString(_options) ? { icon: _options } : _options;

    return getImage({ type: 'Icon', ...options });
};

export const getImgUrl = v => {
    if (v.legend) {
        if (isFunction(v.legend)) {
            return v.legend(v);
        } else if (isString(v.legend) || isObject(v.legend)) {
            return getIcon(v.legend);
        }

        return v.legend;
    } else if (v.style) {
        if (isString(v.style)) {
            return getIcon(v.style);
        } else if (isObject(v.style)) {
            let { type, style } = v.style;
            if (type === 'Marker') {
                if (isString(style)) {
                    return getIcon(style);
                } else if (isObject(style)) {
                    return getIcon(style);
                }
            } else if (type === 'Polyline') {
                return getIcon({ icon: 'GD_CSK', ...(style?.stroke ? style?.stroke : {}) });
            } else if (type === 'Polygon') {
                return getIcon({ icon: 'AREA', ...(style?.fill ? style?.fill : {}) });
            }
        }
    }
};

export const getTreeDataByLayers = data => {
    let treeData = [];
    data.map(v => {
        let item = {
            key: v.key,
            title: v.name,
        };

        let imgUrl = getImgUrl(v);
        if (imgUrl) {
            item.icon = (
                <img src={imgUrl} alt="" className={classname('cs-tools-layer-tree-legend')} />
            );
        }

        if (v.layers?.length) {
            item.children = getTreeDataByLayers(v.layers);
        } else if (v.group?.length) {
            item.children = getTreeDataByLayers(v.group);
        }
        treeData.push(item);
    });

    return treeData;
};

export default function(props) {
    const { map } = useProps();

    const { showAll = true, treeClassName, show, maxHeight, onChange, ...other } = props;
    const [treeData, setTreeData] = useState([]);
    const [checkedKeys, setCheckedKeys] = useState([]);

    useEffect(() => {
        const layersChange = layers => {
            setCheckedKeys(map.getLayersShowKeys());
            setTreeData(getTreeDataByLayers(layers));
        };
        layersChange(map.layers.layers);
        map.layers.on('change', layersChange);

        return () => {
            map.layers.un('change', layersChange);
        };
    }, []);

    const onCheck = checkedKeys => {
        map.setLayersShowByKeys(checkedKeys);
        onChange && onChange(checkedKeys);
    };
    const content = () =>
        treeData?.length > 0 && (
            <div className="cs-tools-layer-tree-wrap" style={{ maxHeight: maxHeight }}>
                <Tree
                    showIcon
                    checkable
                    selectable={false}
                    defaultExpandAll={true}
                    treeData={
                        showAll ? [{ title: '全部', key: 'ALL', children: treeData }] : treeData
                    }
                    checkedKeys={checkedKeys}
                    onCheck={onCheck}
                    rootClassName={classname('cs-tools-layer-tree', treeClassName)}
                    {...other}
                />
            </div>
        );

    return (
        <>
            {show ? (
                <ItemWrap content={props.content || content}>
                    <Icon
                        component={() => (
                            <svg
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                viewBox="0 0 1024 1024"
                            >
                                <path d="M76.885358 279.114423l435.001777 219.929638L946.729127 278.922679 511.887135 66.566904 76.789486 279.018551z m61.070261 341.718631L46.334249 575.23009a73.917067 73.917067 0 0 1 0-136.649103L137.955619 393.073895l-91.62137-45.698835a75.067527 75.067527 0 0 1-38.029101-98.620003 56.915822 56.915822 0 0 1 30.487195-30.359366L473.762163 5.752301a105.45885 105.45885 0 0 1 68.708039 0l435.001777 212.64339a66.72669 66.72669 0 0 1 30.487195 98.651961 58.066282 58.066282 0 0 1-30.487195 30.359365L885.818651 393.073895l83.823807 37.901272a73.086179 73.086179 0 0 1 53.592271 75.994286 78.998266 78.998266 0 0 1-53.592271 75.866458l-83.951635 37.837357 83.951635 37.965186a73.086179 73.086179 0 0 1 53.592271 75.898414 79.253924 79.253924 0 0 1-53.592271 75.962329l-419.566436 204.941699a57.523009 57.523009 0 0 1-38.156929 7.60582 68.196723 68.196723 0 0 1-38.188887-7.637777L38.760386 802.989249a66.72669 66.72669 0 0 1-38.156929-68.452381 73.086179 73.086179 0 0 1 45.730792-68.22868z m83.951636 45.475134l-145.117769 68.22868 435.033735 220.217253L946.729127 742.174646l-144.926026-68.196723-251.822951 121.437463a56.947779 56.947779 0 0 1-38.124972 7.637778 68.196723 68.196723 0 0 1-38.188886-7.637778l-251.854908-129.20307z m579.95976-227.695244l-251.790993 121.437464a105.45885 105.45885 0 0 1-68.708039 0l-259.556599-121.437464-144.926026 68.100851 435.001777 220.313125L946.729127 506.905539l-145.021898-68.196723z" />
                            </svg>
                        )}
                    />
                </ItemWrap>
            ) : (
                <></>
            )}
        </>
    );
}
